module.exports = __webpack_public_path__ + "static/media/Kaustubh_Virkar.f050b297.jpg";